import { SignatureProps } from '../components/signature/signature.js'

export const prepareSignatureElement = (element: HTMLElement): string => {
    if (!element) {
        return ''
    }
    const clonedElement = element.cloneNode(true) as HTMLElement
    clonedElement.style.margin = '0'
    return clonedElement.outerHTML
}

export const createPlainTextSignature = (props: SignatureProps): string => {
    let text = `${props.name}\n${props.title}\n\n`

    if (props.email) {
        text += `Email: ${props.email}\n`
    }

    if (props.website) {
        text += `Web: ${props.website}\n`
    }

    props.customLines?.forEach((line) => {
        if (line.key && line.value) {
            text += `${line.key}: ${line.value}\n`
        } else if (line.key) {
            text += `${line.key}\n`
        }
    })

    return text
}
